import VivViewerLayer from './VivViewerLayer';

export default VivViewerLayer;
